import type { Image } from '~/types/global.types'

export const SEARCH_ITEM_TYPE = {
    MODEL_RANGE: 'MODEL_RANGE',
    PRODUCT: 'PRODUCT',
    DIRECTIONS: 'DIRECTIONS',
} as const

export type TSearchItemType =
    (typeof SEARCH_ITEM_TYPE)[keyof typeof SEARCH_ITEM_TYPE]

export interface ProductSearch {
    type_title: string
    image: Image | Image[] | null
    cost: number | string | null
    link: string
    direction: string
    parent_slug: string
    slug: string
    name: string
    type_name: TSearchItemType
}
